// extracted by mini-css-extract-plugin
export default {"wrapper":"NotFound_wrapper__N40zP","icon":"NotFound_icon__v8pg7","title":"NotFound_title__XKPk3","description":"NotFound_description__Ue7vM"};